import { useNotification, useTimeZone } from '../../../../../hooks'
import { updateMockCalendarTaskDeadline } from '../../../Calendar.mock'
import {
  CalendarTaskMoveModal,
  getCalendarTaskMoveDate,
  getCalendarTaskMoveInitialValues,
} from '../../../CalendarTaskMoveModal'
import { getIsCalendarViewItemChangedMeanwhile } from '../../CalendarView.utils'

export function useCalendarViewTaskMove({
  getActionToken,
  setModal,
  onClose,
  onReload,
}) {
  const timezone = useTimeZone()

  const {
    handleAddErrorNotification,
    handleAddSuccessNotification,
    handleAddWarningNotification,
  } = useNotification()

  function reloadMovedTask({ date, item }) {
    onReload().then(items => {
      if (getIsCalendarViewItemChangedMeanwhile({ date, item, items })) {
        handleAddWarningNotification('Calendar.EntryChangedMeanwhileKey')
      }
    })
  }

  async function handleSubmitTaskMove({
    item,
    payload,
    setSubmitting,
    values,
  }) {
    const actionToken = getActionToken()

    // TODO: write the deadline with updateTask once the feed returns real
    // task ids (TM-01-09).
    return updateMockCalendarTaskDeadline({
      deadline: payload.deadline,
      id: item.id,
      sourceDate: item.date,
      timezone,
    })
      .then(() => {
        if (getActionToken() === actionToken) {
          onClose()
        }

        reloadMovedTask({
          date: getCalendarTaskMoveDate({ timezone, values }),
          item,
        })

        handleAddSuccessNotification('Notification.CommonTitleSavedKey')
      })
      .catch(() => {
        setSubmitting(false)

        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleOpenTaskMove({ date, item }) {
    setModal(
      <CalendarTaskMoveModal
        initialValues={getCalendarTaskMoveInitialValues({
          date,
          item,
          timezone,
        })}
        item={item}
        onClose={onClose}
        onSubmit={handleSubmitTaskMove}
      />
    )
  }

  return { handleOpenTaskMove }
}
